var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.697 17.65 14.711 3.664c-1.205-2.217-4.337-2.217-5.42 0L2.303 17.65c-.963 2 .482 4.349 2.65 4.349h13.973c2.288 0 3.734-2.35 2.77-4.35m-10.6-13.096c.362-.735 1.446-.735 1.807 0l6.986 14c.362.663-.24 1.446-.963 1.446H4.954a.973.973 0 0 1-.843-1.446zm.843 2.265c-.602 0-1.204.567-1.084 1.241l.12 5.627c.121.518.483.928.964.928.482 0 .964-.41.964-.928l.24-5.627c0-.674-.48-1.24-1.204-1.24m-1.325 10.76c0-.772.603-1.398 1.325-1.398.723 0 1.325.626 1.325 1.397s-.602 1.41-1.325 1.41c-.722 0-1.325-.639-1.325-1.41",
    clipRule: "evenodd"
  })));
};
export default SvgIconWarning;